import Api from "./Api";

export const addSubscription = (data: {
  phoneNumber?: string,
  email: string,
}) => Api.post('/newsletter/subscribe', data);
